export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9255.0889f33a.jpg";